import { Layer } from 'const';
import * as Models from 'models';
import { addReusableLayout } from './addReusableLayout';

interface AddReusableLayoutToArtboardResult {
  layouts: Models.LayeredLayouts;
  artboard: Models.Artboard;
  newImages: Models.Images;
  relations: Models.LayeredRelations;
  documents: Models.CombinedDocuments;
}

export function addReusableLayoutToArtboard(
  layoutDocument: Models.ReusableLayout,
  sectionId: string,
  position: number,
  artboard: Models.Artboard,
  projectDocuments: Models.CombinedDocuments,
  layouts: Models.LayeredCombinedLayouts,
  projectBrandDefinition: Models.OnlineBrandDefinition,
  activeLayer: Layer,
  layoutId?: string,
  adoptStyles?: boolean,
): AddReusableLayoutToArtboardResult {
  const {
    layout,
    newImages,
    documents,
    relations,
  } = addReusableLayout(
    layoutDocument,
    sectionId,
    projectDocuments,
    layouts,
    projectBrandDefinition,
    activeLayer,
    layoutId,
    adoptStyles,
  );

  artboard.layoutIds.splice(position, 0, layout.id);

  return {
    artboard,
    newImages,
    documents,
    relations,
    layouts: { [layout.id]: layout },
  };
}
